
<h3>Holdings by Source</h3>
<google-chart
  [type]="chartType"
  [data]="chartDataBySource"
  [options]="chartOptionsBySource"
  [width]="chartWidth"
  [height]="chartHeight">
</google-chart>

<h3>Holdings by Type</h3>
<google-chart
  [type]="chartType"
  [data]="chartDataByType"
  [options]="chartOptionsByType"
  [width]="chartWidth"
  [height]="chartHeight">
</google-chart>


<h3>Holdings by Entity</h3>
<google-chart
  [type]="chartTypeByEntity"
  [data]="chartDataByEntity"
  [options]="chartOptionsByEntity"
  [width]="chartWidth"
  [height]="chartHeight">
</google-chart>

<h3>Bar Chart</h3>
<google-chart
  [type]="chartTypeBar"
  [data]="chartDataBar"
  [options]="chartOptionsBar"
  [width]="chartWidth"
  [height]="chartHeight">
</google-chart>

<h3>Donut Chart</h3>
<google-chart
  [type]="chartTypeDonut"
  [data]="chartDataDonut"
  [options]="chartOptionsDonut"
  [width]="chartWidth"
  [height]="chartHeight">
</google-chart>

<h3>Geo Chart</h3>
<google-chart
  [type]="chartTypeGeo"
  [data]="chartDataGeo"
  [options]="chartOptionsGeo"
  [width]="chartWidth"
  [height]="chartHeight">
</google-chart>
